import { Form as InertiaForm } from '@inertiajs/react'
import { type ComponentProps } from 'react'

import { CommunityOptionType, TaxPayerTypeType } from './types.ts'
import {Input} from "@/components/ui/input.tsx";

type FormProps = Omit<ComponentProps<typeof InertiaForm>, 'children'> & {
  tax_payer_type: TaxPayerTypeType
  communities?: CommunityOptionType[]
  can_select_community?: boolean
  submitText: string
}

export default function Form({ tax_payer_type, communities = [], can_select_community = false, submitText, ...formProps }: FormProps) {
  return (
    <InertiaForm
      transform={data => ({ tax_payer_type: data })}
      className="contents text-foreground bg-background"
      {...formProps}
    >
      {({ errors, processing }) => (
        <>
          <div className="my-5">
            <label htmlFor="name">Nom</label>
            <Input
              type="text"
              name="name"
              id="name"
              defaultValue={tax_payer_type.name}
            />
            {errors.name && (
              <div className="text-red-500 px-3 py-2 font-medium">
                {errors.name.join(', ')}
              </div>
            )}
          </div>

          {can_select_community && (
            <div className="my-5">
              <label htmlFor="community_id">Commune</label>
              <select
                name="community_id"
                id="community_id"
                defaultValue={tax_payer_type.community_id || communities[0]?.id || ""}
                className="block w-full rounded-md border border-input bg-background px-3 py-2 text-sm shadow-sm outline-none"
                required
              >
                <option value="" disabled>Sélectionner une commune</option>
                {communities.map((community) => (
                  <option key={community.id} value={community.id}>
                    {community.name} ({community.code})
                  </option>
                ))}
              </select>
              {errors.community_id && (
                <div className="text-red-500 px-3 py-2 font-medium">
                  {errors.community_id.join(', ')}
                </div>
              )}
            </div>
          )}

          <div className="my-5">
            <label htmlFor="require_nif">Exiger le NIF</label>
            <input type="hidden" name="require_nif" value="0" />
            <input
              type="checkbox"
              name="require_nif"
              id="require_nif"
              value="1"
              defaultChecked={tax_payer_type.require_nif}
              className="block mt-2 h-5 w-5"
            />
            {errors.require_nif && (
              <div className="text-red-500 px-3 py-2 font-medium">
                {errors.require_nif.join(', ')}
              </div>
            )}
          </div>

          <div className="inline">
            <button
              type="submit"
              disabled={processing}
              className="rounded-lg py-3 px-5 bg-blue-600 text-white inline-block font-medium cursor-pointer"
            >
              {submitText}
            </button>
          </div>
        </>
      )}
    </InertiaForm>
  )
}
